import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Box, Button, Card, Collapse, ColorBlock, Flex, Icon, Tag, Text } from 'core/components';
import { SelectedValueButtonProps, SelectedValueButtonState } from 'app/components/device/types';

@observer
class SelectedValueButton extends Component<SelectedValueButtonProps, SelectedValueButtonState> {
  state = {
    isOpen: false
  };

  handleToggleOpen = (e: React.MouseEvent<unknown>) => {
    e.stopPropagation();

    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  handleRemove = () => {
    const { onRemove, option, field } = this.props;
    onRemove?.(option, field);
  };

  render() {
    const { option, style, onRemove, className, disabled, label: propLabel, icon: propIcon } = this.props;
    const { isOpen } = this.state;
    const { label: optionLabel, activeDevices = [], color, iconName: optionIcon } = option || {};
    const iconName = propIcon || optionIcon;
    const label = propLabel || optionLabel;

    const hasDevices = !!(typeof activeDevices === 'number' ? activeDevices : activeDevices?.length);
    const removeButton = onRemove && (
      <Button className={className} onClick={this.handleRemove} icon="cross" disabled={disabled} small minimal />
    );

    const activeDeviceCount = typeof activeDevices === 'number' ? activeDevices : activeDevices?.length;

    return (
      <Card mb={1} style={style}>
        <Flex p="4px" justifyContent="space-between" fontSize="small" alignItems="center">
          <Flex alignItems="center" flex={1} pl="4px">
            <Box mr="6px">
              {color && <ColorBlock color={color} style={{ width: 14, height: 14, minHeight: 14 }} />}
              {!color && <Icon icon={iconName} color="muted" iconSize={14} />}
            </Box>
            {label}
          </Flex>

          {hasDevices &&
            (Array.isArray(activeDevices) ? (
              <Button
                icon={isOpen ? 'caret-down' : 'caret-right'}
                onClick={this.handleToggleOpen}
                className={className}
                text={`${activeDeviceCount} devices`}
                disabled={disabled}
                small
                minimal
              />
            ) : (
              /**
               * TODO CORE-1213: Once we have a simple API for fetching the devices belonging to a given site we could use it here to restore the button
               */
              <Text>{activeDeviceCount} devices</Text>
            ))}

          {removeButton}
        </Flex>

        {Array.isArray(activeDevices) && (
          <Collapse isOpen={isOpen}>
            <Box style={{ padding: '0 8px 4px' }}>
              {activeDevices.map((device) => (
                <Tag key={device.id} mr="4px" mb="4px">
                  {device.device_name}
                </Tag>
              ))}
            </Box>
          </Collapse>
        )}
      </Card>
    );
  }
}

export default SelectedValueButton;
